<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
	equalColumns: {
		type: Boolean,
		default: false
	},
	hasHelpText: {
		type: Boolean,
		default: false
	}
})

const cols = computed(() => {
	return props.equalColumns ? 6 : 12
})

const md = computed(() => {
	return props.equalColumns ? 6 : 8
})

const lg = computed(() => {
	return props.equalColumns ? 6 : 4
})
</script>

<template>
	<v-row align="center" no-gutters>
		<v-col :cols="cols" :md="md" :lg="lg">
			<slot name="prepend-label"></slot>
			<span :class="hasHelpText ? 'pr-2' : 'px-0'">
				<slot name="label"></slot>
			</span>
			<slot name="append-label"></slot>
		</v-col>

		<v-col :cols="cols" :md="md" :lg="lg" class="pt-0">
			<slot name="field"></slot>
		</v-col>
	</v-row>
</template>
